const esc = (s) => String(s ?? "").replace(/[&<>]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;" }[c]));
const fmtD = (s) => {
  if (!s) return "—";
  try { return new Date(s).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" }); }
  catch { return s; }
};
const inr = (v) => `₹ ${Number(v || 0).toLocaleString("en-IN", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
const addMonths = (iso, n) => { const d = new Date(iso); d.setMonth(d.getMonth() + Number(n || 0)); return d.toISOString().slice(0, 10); };

function docHTML(loan, origin) {
  const startISO = loan.disburse_date || new Date().toISOString().slice(0, 10);
  const endISO = addMonths(startISO, loan.tenure_months);
  return `
  <div class="page">
    <img class="watermark" src="${origin}/vns-logo.png" alt="" />
    <header>
      <img src="${origin}/vns-logo.png" alt="VNS" />
      <div class="co">
        <h1>VNS Vinayaka Group of Enterprises</h1>
        <div class="sub">Data Entry Division</div>
      </div>
    </header>
    <div class="title">Service Commitment Agreement</div>
    <div class="meta">
      <span><b>Ref:</b> ${esc((loan.agreement_number || "—").replace("LOAN", "SVC"))}</span>
      <span><b>Date:</b> ${fmtD(startISO)}</span>
    </div>

    <p class="para">This Service Commitment Agreement ("Agreement") is made between
    <b>VNS Vinayaka Group of Enterprises</b> ("the Enterprise") and the employee named below
    ("the Employee"), in consideration of the loan facility extended to the Employee.</p>

    <table class="grid">
      <tr>
        <td style="width:50%"><span class="lbl">Employee Name</span><span class="val"><b>${esc(loan.employee_name)}</b></span></td>
        <td style="width:25%"><span class="lbl">Employee ID</span><span class="val">${esc(loan.employee_id)}</span></td>
        <td style="width:25%"><span class="lbl">Designation</span><span class="val">${esc(loan.designation || "—")}</span></td>
      </tr>
    </table>

    <div class="bond">
      <p>In consideration of the loan of <b>${inr(loan.principal)}</b> granted by the Enterprise, the Employee
      hereby <b>agrees to remain in the continuous service</b> of VNS Vinayaka Group of Enterprises for a
      minimum period of <b>${loan.tenure_months} months</b> ("Service Period"), being equal to the repayment
      tenure of the said loan, counted from the date of disbursement.</p>
      <table class="fin">
        <tr>
          <td class="k">Service Period</td><td class="num"><b>${loan.tenure_months} months</b></td>
          <td class="k">Commences On (Disbursement)</td><td class="num">${fmtD(startISO)}</td>
        </tr>
        <tr>
          <td class="k">To Be Completed On</td><td class="num"><b>${fmtD(endISO)}</b></td>
          <td class="k">Linked Loan Ref</td><td class="num">${esc(loan.agreement_number || "—")}</td>
        </tr>
      </table>
    </div>

    <div class="section">Undertaking &amp; Terms</div>
    <ol class="terms">
      <li>The Employee shall serve the Enterprise faithfully for the entire Service Period of ${loan.tenure_months} months from the date of disbursement.</li>
      <li>If the Employee resigns, abandons employment, or otherwise ceases to serve the Enterprise before completing the Service Period, the <b>entire outstanding loan amount shall become immediately due and payable</b>.</li>
      <li>The Enterprise may recover such outstanding amount by any lawful means, including adjustment against salary, dues and full &amp; final settlement.</li>
      <li>This Service Commitment is in addition to, and read together with, the Employee Loan Agreement executed for the said loan.</li>
      <li>The Employee confirms that this commitment has been made voluntarily, with a full understanding of its terms.</li>
    </ol>

    <div class="declare">
      <p>I, <b>${esc(loan.employee_name)}</b>, voluntarily undertake to serve VNS Vinayaka Group of Enterprises
      for the full Service Period of <b>${loan.tenure_months} months</b> commencing <b>${fmtD(startISO)}</b>
      and ending <b>${fmtD(endISO)}</b>, and I understand that leaving before completing this period makes the
      entire outstanding loan amount immediately payable.</p>
    </div>

    <div class="signs">
      <div class="sigcol">
        <div class="sigline"></div>
        <div class="sigcap">Employee Signature<br/>${esc(loan.employee_name)}</div>
      </div>
      <div class="sigcol">
        <img class="stamp" src="${origin}/vns-stamp.png" alt="" onerror="this.style.display='none'"/>
        <img class="sig" src="${origin}/vns-signature.png" alt="" onerror="this.style.display='none'"/>
        <div class="sigline"></div>
        <div class="sigcap">For VNS Vinayaka Group of Enterprises<br/>Authorised Signatory</div>
      </div>
    </div>
    <div class="bar">Confidential · VNS Vinayaka Group of Enterprises · Service Commitment Agreement</div>
  </div>`;
}

const STYLE = `
  :root{--navy:#0B2545;--gold:#C5A059;--ink:#0f172a;--line:#c7cdd6;--soft:#f4f6f9;}
  *{box-sizing:border-box;}
  body{margin:0;background:#e9edf2;font-family:Georgia,'Times New Roman',serif;color:var(--ink);}
  .toolbar{position:sticky;top:0;background:#0B2545;color:#fff;padding:10px 16px;font-family:Arial,sans-serif;display:flex;gap:10px;align-items:center;z-index:5;}
  .toolbar button{background:#C5A059;color:#0B2545;border:0;padding:8px 16px;border-radius:6px;font-weight:700;cursor:pointer;}
  .page{width:210mm;min-height:297mm;background:#fff;margin:16px auto;padding:16mm 14mm;box-shadow:0 6px 24px rgba(0,0,0,.15);position:relative;}
  .watermark{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:120mm;max-width:70%;opacity:.05;pointer-events:none;}
  header{display:flex;align-items:center;gap:16px;border-bottom:3px solid var(--gold);padding-bottom:10px;}
  header img{height:62px;width:62px;object-fit:contain;}
  .co h1{margin:0;font-size:19px;color:var(--navy);}
  .co .sub{font-family:Arial,sans-serif;font-size:10px;letter-spacing:3px;color:#64748b;text-transform:uppercase;}
  .title{text-align:center;font-family:Arial,sans-serif;font-weight:700;font-size:16px;letter-spacing:3px;color:var(--navy);margin:14px 0 6px;text-transform:uppercase;}
  .meta{display:flex;justify-content:space-between;font-family:Arial,sans-serif;font-size:11px;color:#475569;margin-bottom:12px;}
  .para{font-size:12.5px;line-height:1.6;margin:8px 0;}
  .grid{width:100%;border-collapse:collapse;margin:8px 0;}
  .grid td{border:1px solid var(--line);vertical-align:top;padding:6px 8px;font-family:Arial,sans-serif;}
  .lbl{font-size:8.5px;letter-spacing:.5px;text-transform:uppercase;color:#64748b;display:block;margin-bottom:2px;}
  .val{font-size:12px;}
  .bond{font-size:12.5px;line-height:1.6;border:1.5px solid var(--gold);background:#fbf7ee;border-radius:5px;padding:12px 14px;margin:12px 0;}
  .bond p{margin:0 0 10px;}
  .fin{width:100%;border-collapse:collapse;}
  .fin td{border:1px solid var(--line);padding:8px 10px;font-family:Arial,sans-serif;font-size:12px;}
  .fin .k{background:#fff;color:var(--navy);font-weight:600;width:24%;}
  .fin .num{width:26%;}
  .section{background:var(--navy);color:#fff;font-family:Arial,sans-serif;font-size:12px;letter-spacing:1px;padding:7px 10px;margin:16px 0 8px;text-transform:uppercase;border-radius:3px;}
  .terms{font-size:12px;line-height:1.6;padding-left:20px;margin:0;}
  .terms li{margin-bottom:6px;}
  .declare{font-size:12px;line-height:1.6;margin-top:16px;padding:10px 12px;border:1px dashed var(--line);border-radius:4px;}
  .signs{display:flex;justify-content:space-between;margin-top:48px;gap:40px;}
  .sigcol{flex:1;text-align:center;position:relative;}
  .sigcol .stamp{height:60px;position:absolute;top:-64px;left:50%;transform:translateX(-50%);opacity:.9;}
  .sigcol .sig{height:34px;display:block;margin:0 auto 2px;}
  .sigline{border-top:1px solid #334155;margin-top:30px;}
  .sigcap{font-family:Arial,sans-serif;font-size:10.5px;color:#334155;padding-top:5px;}
  .bar{background:var(--navy);color:var(--gold);text-align:center;font-family:Arial,sans-serif;font-size:9.5px;letter-spacing:1px;padding:6px;margin-top:20px;border-radius:3px;}
  @media print{body{background:#fff;} .toolbar{display:none;} .page{box-shadow:none;margin:0;}}
`;

export function openServiceCommitment(loan) {
  const origin = window.location.origin;
  const title = `Service Commitment · ${loan.employee_name || ""}`;
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"/><title>${title}</title><style>${STYLE}</style></head>
  <body>
    <div class="toolbar"><b>${esc(title)}</b><span style="flex:1"></span><button onclick="window.print()">Print / Save as PDF</button></div>
    ${docHTML(loan, origin)}
  </body></html>`;
  const w = window.open("", "_blank");
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
